import React from "react";
import Dbm from "dbm";
import Website from "../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class Game extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        Website.game.setupAssets();

        this.hasBeenSetup = false;
        this._screens = {};

        this.item.register("game");

        this.item.requireProperty("sessionId", null);
        this.item.requireProperty("runId", null);
        this.item.requireProperty("levelRunId", null);
        this.item.requireProperty("showHighscoreForm", false);

        this.item.requireProperty("email", "");
        this.item.requireProperty("name", "");
        this.item.requireProperty("termsChecked", false);

        this.item.requireProperty("inputMode", "keyboard");
        this.item.requireProperty("currentScreen", null);
        this.item.requireProperty("timer", new Website.game.Timer());

        this.item.requireProperty("playerId", null);
        this.item.requireProperty("level", 1);
        this.item.requireProperty("score", 0);
        this.item.requireProperty("highScore", 0);

        this.item.requireProperty("scale", 1);
        Dbm.flow.addUpdateCommand(this.item.properties.scale, Dbm.commands.callFunction(this._updateSize.bind(this)));
        
        let pixiApplication = new PIXI.Application();
        this.item.requireProperty("pixiApplication", pixiApplication);

        this._createScreen("loadingGame", new Website.game.screens.LoadingGame());
        this._createScreen("start", new Website.game.screens.StartScreen());
        this._createScreen("selectCharacter", new Website.game.screens.SelectCharacter());
        this._createScreen("playerInformation", new Website.game.screens.PlayerInformation());
        this._createScreen("howToPlay", new Website.game.screens.HowToPlay());
        this._createScreen("loadingLevel", new Website.game.screens.LoadingLevel());
        this._createScreen("levelCompleted", new Website.game.screens.LevelCompleted());

        this._createScreen("gamePlay", new Website.game.gameplay.GamePlay());
        
        this._createScreen("preGameOver", new Website.game.screens.PreGameOver());
        this._createScreen("gameOver", new Website.game.screens.GameOverScreen());
    }

    getText(aText, aSize = 16, aColor = 0xFFFFFF, aAdditionalStyles = {}) {

        let scale = this.item.scale;

        let style = {
            ...aAdditionalStyles,
            fontFamily: "'Press Start 2P'",
            fontSize: aSize*scale,
            fill: aColor
        };

        if(style["wordWrapWidth"]) {
            style["wordWrapWidth"] *= 2*this.item.scale;
        }
        if(style["lineHeight"]) {
            style["lineHeight"] *= this.item.scale;
        }

        let text = new PIXI.Text({
            text: aText,
            style: style
        });

        text.scale.set(1/(2*scale));

        return text;
    }

    _createScreen(aName, aController) {
        this.item.requireProperty(aName, aController.item);
        aController.item.setValue("prepared", false);
        aController.item.setValue("game", this.item);
        this._screens[aName] = aController.item;
    }

    async setup() {
        await this.item.pixiApplication.init({
            width: this.item.scale*Website.game.Sizes.WIDTH,
            height: this.item.scale*Website.game.Sizes.HEIGHT,
            backgroundColor: 0x000000
        });

        await document.fonts.load("16px 'Press Start 2P'");

        this.item.pixiApplication.view.style.touchAction = "pan-y";

        if('audioSession' in navigator) {
            navigator.audioSession.type = 'ambient';
        }

        this.mainContainer = new PIXI.Container();
        this.mainContainer.scale.set(this.item.scale);

        this.item.pixiApplication.stage.addChild(this.mainContainer);

        this.gameContainer = new PIXI.Container();
        this.mainContainer.addChild(this.gameContainer);

        this.overlayContainer = new PIXI.Container();
        this.mainContainer.addChild(this.overlayContainer);

        let highscoreList = new Website.game.screens.HighscoreList();
        highscoreList.item.setValue("game", this.item);
        this.item.setValue("highscoreList", highscoreList.item);
        this.overlayContainer.addChild(highscoreList.item.pixiLayer);
        
        this.hasBeenSetup = true;
        this._updateSize();
    }

    _updateSize() {
        if(this.hasBeenSetup) {
            this.item.pixiApplication.renderer.resize(this.item.scale*Website.game.Sizes.WIDTH, this.item.scale*Website.game.Sizes.HEIGHT);
            this.mainContainer.scale.set(this.item.scale);
        }
        
    }

    async start() {
        //console.log("start");

        this.item.pixiApplication.ticker.add(this._callback_updateTime.bind(this));

        this.changeScreen("loadingGame");
    }

    enableGameMode() {
        this.item.pixiApplication.canvas.style.touchAction = "none";
        this.item.pixiApplication.canvas.addEventListener("contextmenu", e => e.preventDefault());
        this.item.pixiApplication.canvas.addEventListener("touchstart", e => e.preventDefault(), { passive: false });
        this.item.pixiApplication.canvas.addEventListener("touchend", e => e.preventDefault(), { passive: false });
    }

    scrollIntoView() {
        this.item.pixiApplication.view.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    }

    _callback_updateTime(aDelta) {
        //console.log("_callback_updateTime");

        if(this.item.currentScreen) {
            this.item.timer.update();
            this.item.currentScreen.controller.update();
        }
    }

    changeScreen(aName) {
        let lastScreen = this.item.currentScreen;
        if(lastScreen) {
            this.gameContainer.removeChild(lastScreen.pixiLayer);
            lastScreen.controller.stop();
        }

        let newScreen = this._screens[aName];

        if(!newScreen.prepared) {
            newScreen.controller.prepare();
            newScreen.prepared = true;
        }

        this.item.timer.restart();
        this.gameContainer.addChild(newScreen.pixiLayer);
        newScreen.controller.start();
        newScreen.controller.update();

        this.item.currentScreen = newScreen;
    }

    startSession() {
        //console.log("startSession");
        this.item.highscoreList.controller.setup();

        Dbm.graphapi.webclient.performAction("game/startSession", {}, this._callback_sessionLoaded.bind(this));
    }

    _callback_sessionLoaded(aData) {
        //console.log("_callback_sessionLoaded");
        //console.log(aData);

        this.item.sessionId = aData["id"];
    }

    startRun() {
        //console.log("startRun");

        Dbm.graphapi.webclient.performAction("game/startRun", {"session": this.item.sessionId, "player": this.item.playerId}, this._callback_runLoaded.bind(this));
    }

    _callback_runLoaded(aData) {
        //console.log("_callback_runLoaded");
        //console.log(aData);

        this.item.runId = aData["id"];
    }

    startLevel() {
        //console.log("startLevel");

        Dbm.graphapi.webclient.performAction("game/startLevel", {"run": this.item.runId, "score": this.item.score, "level": this.item.level}, this._callback_levelRunLoaded.bind(this));
    }

    _callback_levelRunLoaded(aData) {
        //console.log("_callback_levelRunLoaded");
        //console.log(aData);

        this.item.levelRunId = aData["id"];
    }

    endLevel(aCompleted, aDetails = null) {
        Dbm.graphapi.webclient.performAction("game/endLevel", {"completed": aCompleted, "id": this.item.levelRunId, "score": this.item.score, "details": aDetails}, this._callback_endLevelLoaded.bind(this));
    }

    _callback_endLevelLoaded(aData) {
        //console.log("_callback_endLevelLoaded");
        //console.log(aData);

    }

    submitHighscore() {
        Dbm.graphapi.webclient.performAction("game/submitHighscore", {"id": this.item.runId, "score": this.item.score, "name": this.item.name, "email": this.item.email, "gameMode": Dbm.repository.getItem("site").gameMode}, this._callback_submitScoreLoaded.bind(this));
    }

    _callback_submitScoreLoaded(aData) {
        //console.log("_callback_submitScoreLoaded");
        //console.log(aData);
    }

    showHighscoreList() {
        this.item.highscoreList.controller.updateScores();
        this.item.highscoreList.controller.updateCurrentPosition();
        this.item.highscoreList.controller.updateHighscorePosition();
        this.item.highscoreList.controller.show();
    }
}